import { useMemo, useState } from "react"
import { style } from "typestyle"

interface Rotator_Box_Props {
    /* size in em units */
    size: number
    letters: string
}

export const Rotator_Box = (props: Rotator_Box_Props) => {

    /* useMemo here so that we only ever generate all the styles once for a given size in props */
    const styles = useMemo(() => get_styles(props.size), [props.size])

    const faces = ['rotated_to_front','rotated_to_right','rotated_to_back','rotated_to_left','rotated_to_top','rotated_to_bottom']

    /* The state here just stores which css class from styles to add to rotate the box */
    const [ rotated_to, set_rotated_to ] = useState(0)

    return (
        <>
        <div onClick={() => set_rotated_to(Math.floor(Math.random() * 6))} className={styles.scene}>
            <div className={styles.cube + ' ' + styles[faces[rotated_to]]}>
                <div className={styles.cube_face + ' ' + styles.cube_face_front}><span className={styles.cube_face_text}>{props.letters[0]}</span></div>
                <div className={styles.cube_face + ' ' + styles.cube_face_back}><span className={styles.cube_face_text}>{props.letters[1]}</span></div>
                <div className={styles.cube_face + ' ' + styles.cube_face_right}><span className={styles.cube_face_text}>{props.letters[2]}</span></div>
                <div className={styles.cube_face + ' ' + styles.cube_face_left}><span className={styles.cube_face_text}>{props.letters[3]}</span></div>
                <div className={styles.cube_face + ' ' + styles.cube_face_top}><span className={styles.cube_face_text}>{props.letters[4]}</span></div>
                <div className={styles.cube_face + ' ' + styles.cube_face_bottom}><span className={styles.cube_face_text}>{props.letters[5]}</span></div>
            </div>
        </div>
        </>
    )
}

/* Generate the css for a given size */
function get_styles(size: number) {

    const size_ems = `${size}em`
    const perspective_size = `${size * 3}em`
    const translate_z_part = `translateZ(${size/2}em)`
    const neg_translate_z_part = `translateZ(${- size/2}em)`

    const styles: { [index: string]: string} = {
        scene: style({
            display: 'inline-block',
            width: size_ems, 
            height: size_ems, 
            perspective: perspective_size
        }),
        cube: style({
            width: '100%',
            height: '100%',
            position: 'relative',
            transformStyle: 'preserve-3d',
            transform: neg_translate_z_part,
            transition: 'transform 1s',
        }),
        cube_face: style({
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'space-around',
            opacity: '0.8',
        }),
        cube_face_text: style({
            fontSize: size_ems
        }),
        cube_face_front:  style({ transform: `rotateY(  0deg) ${translate_z_part}`, backgroundColor: 'rgba(245, 234, 31, 1)' }),
        cube_face_right:  style({ transform: `rotateY( 90deg) ${translate_z_part}`, backgroundColor: 'rgba(120, 110, 8, 1)' }),
        cube_face_back:   style({ transform: `rotateY(180deg) ${translate_z_part}`, backgroundColor: 'rgba(14, 42, 202, 1)' }),
        cube_face_left:   style({ transform: `rotateY(-90deg) ${translate_z_part}`, backgroundColor: 'rgba(37, 125, 225, 1)' }),
        cube_face_top:    style({ transform: `rotateX( 90deg) ${translate_z_part}`, backgroundColor: 'rgba(106, 11, 201, 1)' }),
        cube_face_bottom: style({ transform: `rotateX(-90deg) ${translate_z_part}`, backgroundColor: 'rgba(168, 0, 73, 1)' }),

        rotated_to_front: style({ transform: 'translateZ(-6em) rotateY(   0deg)' }),
        rotated_to_right: style({ transform: 'translateZ(-6em) rotateY( -90deg)' }),
        rotated_to_back:  style({ transform: 'translateZ(-6em) rotateY(-180deg)' }),
        rotated_to_left:  style({ transform: 'translateZ(-6em) rotateY(  90deg)' }),
        rotated_to_top:   style({ transform: 'translateZ(-6em) rotateX( -90deg)' }),
        rotated_to_bottom: style({ transform: 'translateZ(-6em) rotateX(  90deg)' }),
    }

    return styles
}

